import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  openedStations: null,
  selectedMenuStation: null,
  menuItemsOpenedAcc: null,
};

const stationsSlice = createSlice({
  name: "stations",
  initialState,
  reducers: {
    setOpenedStations(state, action) {
      state.openedStations = action.payload;
    },
    setSelectedMenuStation(state, action) {
      state.selectedMenuStation = action.payload;
    },
    setMenuItemsOpenedAcc(state, action) {
      state.menuItemsOpenedAcc = action.payload;
    },
  },
});

export const { setOpenedStations, setSelectedMenuStation, setMenuItemsOpenedAcc } = stationsSlice.actions;
export default stationsSlice.reducer;
